import { useState, useEffect } from 'react';
import { TextareaHookProps } from '@/shared/types/textarea';

export const useTextarea = ({ maxLength = 0, onChange, value }: TextareaHookProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const [count, setCount] = useState(() => (value || '').length);

  // Sincronizar contador cuando cambie el value externo
  useEffect(() => {
    const newCount = (value || '').length;
    setCount((prev) => {
      // Solo actualizar si el contador es diferente
      if (prev !== newCount) {
        return newCount;
      }
      return prev;
    });
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    const count = newValue.length;

    if (maxLength > 0 && count > maxLength) {
      // Permitir pegar solo la cantidad que quepa
      const truncatedValue = newValue.substring(0, maxLength);
      setCount(maxLength);
      onChange?.(truncatedValue);
      return;
    }

    setCount(count);
    onChange?.(newValue);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    if (maxLength > 0) {
      const pastedText = e.clipboardData.getData('text');
      const currentValue = value || '';
      const newLength = currentValue.length + pastedText.length;

      if (newLength > maxLength) {
        e.preventDefault();
        // Calcular cuánto texto cabe
        const availableSpace = maxLength - currentValue.length;
        const truncatedPaste = pastedText.substring(0, availableSpace);

        if (availableSpace > 0) {
          const newValue = currentValue + truncatedPaste;
          setCount(newValue.length);
          onChange?.(newValue);
        }
      }
    }
  };

  return { isFocused, setIsFocused, count, handleChange, handlePaste };
};
